import { create } from 'zustand';
import type { ResourceHistoryItem } from '../../shared/types';

interface ResourceHubDetailData {
  documentId: string;
  title: string;
  slug: string;
  briefDescription?: string | null;
  subHeader?: string | null;
  publicationDate?: string | null;
  resourceStatus?: 'New' | 'Updated' | null;
  expireResourceStatusAt?: string | null;
  type?: {
    documentId: string;
    type: string;
  } | null;
  category?: {
    documentId: string;
    category: string;
  } | null;
  cover?: {
    url?: string | null;
    alternativeText?: string | null;
    mime?: string | null;
  } | null;
  resourceHistory?: ResourceHistoryItem[] | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  DefaultContentTemplate?: any[] | null;
}

interface ResourceHubDetailState {
  resource: ResourceHubDetailData | null;
  loading: boolean;
}

interface ResourceHubDetailActions {
  setResource: (resource: ResourceHubDetailData | null) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

const initialState: ResourceHubDetailState = {
  resource: null,
  loading: false,
};

export const useResourceHubDetailStore = create<ResourceHubDetailState & ResourceHubDetailActions>((set) => ({
  ...initialState,
  setResource: (resource) => set({ resource }),
  setLoading: (loading) => set({ loading }),
  reset: () => set(initialState),
}));
